import { Box } from '@mui/material';
import { FC } from 'react';
import { useApptRequestsWidget } from '../../../../hooks/use-appt-requests-widget';

export const EndOfList: FC = () => {
  const { allApptRequestsLoaded } = useApptRequestsWidget();

  return (
    <>
      {allApptRequestsLoaded && (
        <Box
          sx={{
            display: 'flex',
            margin: '30px auto',
            justifyContent: 'center',
            fontSize: '14px',
            fontWeight: 500
          }}
        >
          End of the list
        </Box>
      )}{' '}
    </>
  );
};
